module.exports = {
  // The application name, to be used when asking the configuration system for settings
  appName: 'UpfAssignHost', // TODO: 1. Set this to the name of the host application
  // These applications are referenced by the project in an unbuilt state, and require babel to also be run over them.
  // The package's ES2015 dist must be transpiled or webpack 2's UglifyJS fails to minify it.
  childApplications: [
    '@3plearning/mx-teacher-analytics',
    '@3plearning/teacher-totter',
    'posthog-js'
  ]
};
